<design-slide-up-card
  #card
  [isCardOpen]="!!isCardOpen"
  [displayBackground]="true"
  [title]="data.title"
  [roleDialog]="true"
  [focusInitialOnHeaderBack]="false"
  (onHeaderButtonClick)="handleClose()"
  [icon]="iconName"
  class="route-planner-autocomplete"
  >
  <div class="flex flex-col py-4 px-2 gap-2 min-h-0 flex-1">
    <!--
      a11y: WAI-ARIA combobox-autocomplete-list pattern.
      - Input exposes role="combobox" + aria-autocomplete="list" + aria-controls/expanded/activedescendant
        via the comboboxRole inputs on <mot-input>.
      - Filtered results below are wrapped in <ul role="listbox"> with role="option" rows.
      - Arrow/Enter/Home/End/Escape are handled via (keydown) on the input (events bubble
        out of the inner <input> through this host).
    -->
    <mot-input
      #input
      [autoFocus]="false"
      [formControl]="formControl"
      [displayErrors]="false"
      appearance="fill"
        [icon]="
          input.formControl?.value?.length >= autoCompleteMinChar
            ? 'close'
            : null
        "
      iconClass="text-xl cursor-pointer"
      prefixIcon="search"
      prefixIconClass="text-xl"
      (onIconClick)="clearValue()"
      [iconButtonAriaLabel]="clearText"
      [placeholder]="insertAddressText"
      [ariaLabel]="insertAddressText"
      [comboboxRole]="true"
      [comboboxControlsId]="listboxId"
      [comboboxExpanded]="isListboxExpanded"
      [comboboxActiveDescendant]="activeOptionId"
      (keydown)="onComboboxKeydown($event)"
      class="bg-transparent w-full leading-loose !text-default"
      [dir]="direction"
      [attr.cdkFocusInitial]="true"
      />

      <div class="py-4 flex flex-col gap-6 flex-1 overflow-y-auto" [class]="direction">
        @if (!!this.formControl.value) {
          @if (results$ | async; as addresses) {
            @if (
              formControl.value.length >= autoCompleteMinChar &&
              (emptyResults$ | async) == true) {
              <div class="px-2">
                <p class="m-0 text-wrap">
                  {{ noResultsText }} {{ forText }} {{ formControl.value }}
                </p>
              </div>
              <!-- <div
              class="flex gap-2 cursor-pointer"
              (click)="handleMapClick(formControl.value)"
              >
              <ng-icon class="text-base" name="map-location-dot" />
              <span>{{ searchOnMapText }}</span>
            </div> -->
            <button
              type="button"
              class="flex gap-2 rounded bg-transparent p-0 text-start border-0 text-inherit w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
              [class.cursor-pointer]="!missingSearchSentViaButton"
              [class.opacity-60]="missingSearchSentViaButton"
              [disabled]="missingSearchSentViaButton"
              (click)="sendMissingSearch()"
              >
              <ng-icon class="text-base shrink-0" [name]="missingSearchSentViaButton ? 'check' : 'plus'" aria-hidden="true" />
              <span>{{ missingSearchSentViaButton ? poiRequestSentText : askPoiText }}</span>
            </button>
          } @else {
            <!--
              a11y: listbox owns role="listbox" + an accessible name (insertAddressText).
              list-none keeps the visual layout while ul/li keep the listbox semantics.
            -->
            <ul
              [id]="listboxId"
              role="listbox"
              [attr.aria-label]="insertAddressText"
              tabindex="-1"
              class="list-none m-0 p-0 flex flex-col gap-6"
              (focus)="onListboxContainerFocus($event)"
              (keydown)="onListboxKeydown($event)">
              @for (address of addresses; track address; let i = $index) {
                <app-address-auto-complete-result
                  [optionMode]="true"
                  [optionId]="getOptionId(i)"
                  [isActive]="activeOptionIndex === i"
                  [address]="address.value"
                  [icon]="getAddressIcon(address.value)"
                  [main]="address.value.addressDetails.label"
                  [sub]="getAddressSub(address.value)"
                  (optionFocus)="onOptionFocus(i)"
                  (onResultClick)="
                    chooseValue($event, !!data.saveResultToStorage)
                  " />
              }
            </ul>
          }
        }
      } @else {
        @if (!data.hideFeed) {
          <app-address-auto-complete-feed
            [favoriteAddresses]="favoriteAddresses"
            (onLastSearchClick)="chooseValue($event, false)"
            (onHomeClick)="handleHomeClick($event)"
            (onWorkClick)="handleWorkClick($event)"
            (onMapClick)="handleMapClick()"
            (onCurrentLocationClick)="handleCurrentLocationClick()"
            [isCurrentLocationLoading]="isCurrentLocationLoading"
            />
        }
      }


    </div>
  </div>
</design-slide-up-card>
